import { PaymentType } from "../../payment-types/models/PaymentType";
import { ProgrammeSummary } from "../models/Programme";

/**
 * Whether enrolling in this programme offers the per-visit account (PD-0019): only a
 * licence-class programme does (PD-0023), whether copied from a template or the school's
 * own plan with a class.
 */
export const offersPerVisitContract = (programme: ProgrammeSummary | undefined): boolean =>
  programme?.isLicenceClassProgramme === true;

/**
 * The names the Fahrschule preset gives the regular 45-minute lesson Payment Type, one per
 * organization language (Instructors/Services/FahrschulePresetStrings.cs, PracticeLesson).
 */
const PRESET_LESSON_NAMES: string[] = [
  "Practice lesson (45 min)",
  "Übungsstunde (45 min)",
  "Практичне заняття (45 хв)",
  "Jazda ćwiczebna (45 min)",
  "練習教習（45分）",
];

/** Same name the way the preset's re-apply matches: trimmed, case-insensitive. */
const sameName = (a: string, b: string): boolean => a.trim().toLowerCase() === b.trim().toLowerCase();

/**
 * The Payment Type pre-selected for the per-visit account: the preset's lesson type when it is
 * still active, otherwise the first active one; null when the organization has none.
 */
export const pickPerVisitPaymentType = (activePaymentTypes: PaymentType[]): string | null => {
  const lesson = activePaymentTypes.find((p) => PRESET_LESSON_NAMES.some((name) => sameName(p.name, name)));
  return (lesson ?? activePaymentTypes[0])?.id ?? null;
};
